import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IMatrizConsolidadaUgSecaoModel, IMatrizConstatacaoModel } from "../../../../../models/constatacao.model";
import { MatrizConstatacoesService } from "../../../../../services/matriz-constatacao.service";
import { SharedService } from "../../../../../services/shared.service";
import { PrintLayoutComponent } from "../../../../../shared/components/print-layout/print-layout.component";

@Component({
  selector: 'app-modal-visualizar-matriz',
  templateUrl: './modal-visualizar-matriz-constatacao.component.html',
  styleUrls: ['./modal-visualizar-matriz-constatacao.component.scss']
})
export class ModalVisualizarMatrizComponent implements OnInit {
  public matriz: IMatrizConstatacaoModel;
  public loading = false;
    public tipoMatriz = '';
    public titulo = '';
    public unidageGestoraNome = '';
    public secoes: IMatrizConsolidadaUgSecaoModel[] = []; // ✅ novo


  constructor(
    private dialogRef: MatDialogRef<ModalVisualizarMatrizComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private matrizService: MatrizConstatacoesService,
    public sharedaService: SharedService
  ) {}

  ngOnInit(): void {
    this.tipoMatriz = this.data.tipoMatriz;
    this.titulo = this.data.titulo;
    this.unidageGestoraNome = this.data.nomeUnidade;
    this.secoes = this.data.secoes ?? []; // ✅ novo

    // consolidada não precisa carregar matriz única
    if (this.tipoMatriz !== 'consolidada') {
      this.carregarMatriz();
    }
  }

  private carregarMatriz(): void {
    this.loading = true;

    let promise: Promise<any>;
    if (this.data.tipoMatriz === 'preliminar') {
      promise = this.matrizService.obterPorId(this.data.matrizId);
    } else if (this.data.tipoMatriz === 'definitiva') {
      promise = this.matrizService.obterPorId(this.data.matrizId, true);
    } else {
      promise = this.matrizService.obterPorId(this.data.matrizId);
    }

    promise
      .then(res => {
        if (res?.sucesso && res?.dados) {
          this.matriz = res.dados;
        }
      })
      .finally(() => this.loading = false);
  }

  public  pegarAnoOsa(valor: string): string | null {
    if (!valor) return null;

    const match = valor.match(/\.(\d{4})/);

    return match ? match[1] : null;
  }

  // ModalVisualizarMatrizComponent
  public imprimir(): void {
    window.scrollTo(0, 0);

    window.print(); // igual ao ImprimirMatrizConstatacaoComponent
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  formatarRecomendacoes(recomendacoes: any[]): string {
    if (!recomendacoes || recomendacoes.length === 0) return '-';

    const textos = recomendacoes
      .map(rec => rec.titulo || rec.descricao || '')
      .filter(texto => texto);

    if (textos.length === 0) return '-';

    return textos
      .map((texto, i) => textos.length > 1 ? `Rec.${String(i + 1).padStart(2, '0')}: ${texto}` : texto)
      .join('\n');
  }
  extrairTextoSemPrefixo(texto: string): string {
    if (!texto) return '';

    return texto
      .replace(/^Arquivo:\s*/i, '')
      .replace(/^Link:\s*/i, '')
      .replace(/^Justificativa:\s*/i, '')
      .trim();
  }

  formatarUrl(url: string): string {
    if (!url) return '';

    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }

    return 'https://' + url;
  }


  public fechar(): void {
    this.dialogRef.close();
  }
  public extrairUrl(texto?: string): string {
    if (!texto) return '#';
    const match = texto.match(/https?:\/\/[^\s]+/i);
    return match?.[0] || texto;
  }
}
